export default __webpack_public_path__ + "static/media/lose.cb3e1cf9.wav";